import { render, staticRenderFns } from "./TableOrder.vue?vue&type=template&id=00132668&scoped=true"
import script from "./TableOrder.vue?vue&type=script&lang=js"
export * from "./TableOrder.vue?vue&type=script&lang=js"
import style0 from "./TableOrder.vue?vue&type=style&index=0&id=00132668&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00132668",
  null
  
)

export default component.exports